export default __webpack_public_path__ + "static/media/auth-bg.693eafa1.jpg";